import React, { useEffect, useState } from "react";
import Carousel_Img01 from "../../../assets/img/hero-carousel/hero-carousel-1.jpg";
import Carousel_Img02 from "../../../assets/img/hero-carousel//hero-carousel-2.jpg";
import Carousel_Img03 from "../../../assets/img/hero-carousel/hero-carousel-3.jpg";
import Carousel_Img04 from "../../../assets/img/hero-carousel/hero-carousel-4.jpg";
import Carousel_Img05 from "../../../assets/img/hero-carousel/hero-carousel-5.jpg";
import './index.css'
import { Helmet } from "react-helmet";
import UserAPI from "../../../api/services/userapi";
import { baseURL } from "../../../api/api";
import NoDataFound from '../../../assets/img/nodata-found.png';
import Loading from "../../common/loading";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Carousel } from "bootstrap";

function Home_Component() {
  const [homebanner, sethomeBanner] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const homeBanner = async (page) => {
    setLoading(true);
    try {
      const responseData = await UserAPI.homeBannerAPIEP({
        pageIndex: page - 1,
        dataLength: 10,
      });
      if (responseData.apiStatus.code === "200") {
        setLoading(false)
        sethomeBanner(responseData.responseData);
      } else {
        sethomeBanner([]);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    homeBanner(currentPage);
  }, [currentPage]);

  useEffect(() => {
  if (homebanner.length > 0) {
    const carouselElement = document.getElementById("hero-carousel");

    if (carouselElement) {
      const carouselInstance = new Carousel(carouselElement, {
        interval: 5000,  
        ride: "carousel",
        pause: false, 
        wrap: true
      });

      return () => {
        carouselInstance.dispose();
      };
    }
  }
}, [homebanner]);


  return (
    <>
      <Helmet> <title>Home | GreenDart Builders</title> </Helmet>
      <div id="hero" class="hero section dark-background">
        {loading ? (
          <Loading />
        ) : homebanner.length === 0 ? (
          <div className="d-flex justify-content-center">
            <img
              src={NoDataFound}
              alt="No data found"
              style={{ maxWidth: "250px", height: "100%" }}
            />
          </div>
        ) : (
          <>
            <div class="info d-flex align-items-center">
              <div class="container">
                <div
                  class="row justify-content-center"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div class="col-lg-12 text-center">
                    {/* <h2 className="banner-heading">
                  WELCOME TO <br /> <span style={{ fontSize: "58px", }}>GREEN DART BUILDERS</span>
                </h2> */}
                    {/* <p className="fs-5 home-desc text-justify">
                  Construction, we believe every project is more than just bricks and mortar. it's Residences that offer unforgettable memories close to the heart. Residences where water, land, air, sun and moon are our own. The beauty of the village, the life intertwined with nature, the uniqueness of that house. Wherever we go in the world, Residences should be established places that make us feel like coming back to our mother's lap.
                </p> */}
                    {/* <a href="#get-started" class="btn-get-started">
                  Read more
                  <i className="fa-solid fa-angle-right"></i>
                </a> */}
                  </div>


                </div>
              </div>
              {/* </div> */}
            </div>

            <div
              id="hero-carousel"
              className="carousel slide"
              // data-bs-ride="carousel"
              // data-bs-interval="5000"
            >

              {homebanner.map((listData, ind) => (
                <div key={ind} className={`carousel-item ${ind === 0 ? "active" : ""}`}>
                  <img src={baseURL + listData?.path + listData?.altered_name} alt="" />
                </div>
              ))}

              <a
                class="carousel-control-prev"
                href="#hero-carousel"
                role="button"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon bi bi-chevron-left"
                  aria-hidden="true"
                ></span>
              </a>

              <a
                class="carousel-control-next"
                href="#hero-carousel"
                role="button"
                data-bs-slide="next"
              >
                <span
                  class="carousel-control-next-icon bi bi-chevron-right"
                  aria-hidden="true"
                ></span>
              </a>
            </div></>)}
      </div>
      <div className="container">
        <div className="row" style={{
          marginTop: "-77px", zIndex: "2",
          position: "relative", boxShadow: "0 0 0 0px #fff,0 0 0 calc(1px + 0px) oklch(30.39% .04 213.68 / .1),0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1),0 0 #0000"
        }}>

          {/* LEFT SIDE */}
          <div className="col-md-4" style={{ backgroundColor: "#48a0dc" }}>
            <p className="rent-info">
              <h1 className="text-center" style={{ color: "black", fontSize: "35px", letterSpacing: "1px", textTransform: "capitalize", fontWeight: 600 }}>
                We Build Spaces that Brings Smiles
              </h1>
              {/* <h2 style={{ color:"white", letterSpacing:"1px",fontSize:"1.5em",marginTop:"10px" }}>
                  live in dream home
                </h2> */}
              <p className="para-center mt-4" style={{ textAlign: "justify", color: "#1b3346", fontSize: "1.1em", fontweight: "300", textTransform: "capitalize", lineHeight: "2em" }}>
                We build strong, long-lasting residential Building and commercial building with modern designs and premium materials. We team build homes that stand the test of time.

              </p>
            </p>
          </div>

          {/* RIGHT SIDE – 2 × 2 GRID */}
          <div className="col-md-8">
            <div className="row text-center">

              {/* 1 */}
              <div className="col-md-6 white-bg py-4">
                <i className="fas fa-home homeicon"></i>
                <h3 className="rent-textcolor mt-2">Building Work</h3>
                <p className="rent-para text-justify px-4">
                  Building Your dream home and commercial building with a beautiful appearance, Strength, and with the right vasthu Plan.
                </p>
              </div>

              {/* 2 */}
              <div className="col-md-6 white-bg py-4">
                <i className="fas fa-warehouse homeicon"></i>
                <h3 className="rent-textcolor">Drawing</h3>
                <p className="rent-para text-justify px-4">
                 We create 2D and 3D architectural drawings and plans, along with modelling that enhances interior and exterior spaces, optimizes space usage, and follows modern construction principles for every type of project.
                </p>
              </div>

              {/* 3 */}
              <div className="col-md-6 white-bg py-4">
                <i className="fab fa-accusoft homeicon"></i>
                <h3 className="rent-textcolor">Plan Approval</h3>
                <p className="rent-para text-justify px-4">
                  We draw Panchayat and Municipal approval plan for the Residential building and Commercial building we construct.
                </p>
              </div>

              {/* 4 */}
              <div className="col-md-6 white-bg py-4">
                <i className="fab fa-monero homeicon"></i>
                <h3 className="rent-textcolor">Housing loan</h3>
                <p className="rent-para text-justify px-4">
                  We arrange for you to get financial assistance from government-approved banks to build a house.
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Home_Component;
